import supabase from "../config/supabase";

export const deviceTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export const validReminderTime = (value) => /^([01]\d|2[0-3]):[0-5]\d$/.test(value);

const dailyReminderApi = {
  async get() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error("Please sign in first.");
    const { data, error } = await supabase.from("daily_reminder_preferences")
      .select("enabled,reminder_time,time_zone").eq("user_id", user.id).maybeSingle();
    if (error) throw new Error("Daily reminders aren't ready yet. Please try again later.");
    return data ? { ...data, reminder_time: data.reminder_time.slice(0, 5) }
      : { enabled: false, reminder_time: "06:00", time_zone: deviceTimeZone() };
  },
  async save({ enabled, reminder_time }) {
    if (!validReminderTime(reminder_time)) throw new Error("Enter a time such as 06:00 using the 24-hour clock.");
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error("Please sign in first.");
    const time_zone = deviceTimeZone();
    const { error } = await supabase.from("daily_reminder_preferences").upsert({
      user_id: user.id, enabled, reminder_time, time_zone,
    });
    if (error) throw new Error("Couldn't save your daily reminder. Please try again.");
    return { enabled, reminder_time, time_zone };
  },
  async syncTimeZone() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    const { error } = await supabase.from("daily_reminder_preferences")
      .update({ time_zone: deviceTimeZone() }).eq("user_id", user.id);
    if (error) throw error;
  },
};
export default dailyReminderApi;
